var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box, Card, CardMedia, Typography } from '@mui/material';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var CategoryCard = function (_a) {
    var title = _a.title, imgSrc = _a.imgSrc, imgSrcSet = _a.imgSrcSet, imgAlt = _a.imgAlt, imgLoading = _a.imgLoading, onClick = _a.onClick, props = __rest(_a, ["title", "imgSrc", "imgSrcSet", "imgAlt", "imgLoading", "onClick"]);
    return (React.createElement(Card, __assign({ onClick: onClick, sx: __assign({ width: '100%', height: '144px' }, (onClick
            ? {
                cursor: 'pointer',
                '&:hover': {
                    borderColor: designTokens.color.gray.accent.value,
                    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.15)',
                },
                '&:active': {
                    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.15)',
                },
            }
            : {
                '&:hover': {
                    borderColor: designTokens.color.gray.accent.value,
                    boxShadow: 'none',
                },
            })) }, props),
        React.createElement(Box, { sx: {
                zIndex: '10',
                padding: '15px 19% 15px 16px',
                background: 'linear-gradient(105deg, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0) 75%)',
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: '20%',
            } },
            React.createElement(Typography, { variant: "heading4", sx: {
                    color: designTokens.color.gray.obsidian.value,
                    textShadow: '0px 1px 10px #ffffff, 0px 1px 1px #ffffff88',
                } }, title)),
        React.createElement(Box, { sx: {
                display: 'flex',
                position: 'absolute',
                top: '-10px',
                right: '-10px',
                bottom: '-10px',
                left: '40%',
                justifyContent: 'center',
            } },
            React.createElement(CardMedia, { sx: {
                    width: 'auto',
                    height: '100%',
                    objectFit: 'contain',
                }, component: "img", src: imgSrc, srcSet: imgSrc, alt: imgAlt || title, loading: imgLoading }))));
};
export default CategoryCard;
//# sourceMappingURL=CategoryCard.js.map